import { addDays } from "date-fns"
import { OrderStatus } from "../converters/labels"
import { CompletedOrder } from "../types"

const MAX_REFOUND_DAYS = 30

export const getMaxRefoundDate = (order: CompletedOrder) =>
  order.delivery
    ? addDays(new Date(order.delivery.deliveredDate), MAX_REFOUND_DAYS)
    : undefined

export const hasPendingPayment = (order: CompletedOrder) =>
  (order.editOrderPendingPayment?.amount ?? 0) > 0

export const isRefundable = (order: CompletedOrder) =>
  !!(
    (order.status as OrderStatus) === "delivered" &&
    order.delivery?.deliveredDate &&
    (getMaxRefoundDate(order) as Date) >= new Date()
  )
